import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contact from './components/pages/Contact';
import Aboutpage from './components/pages/Aboutpage';
import Doctorpage from './components/pages/Doctorpage';
import Shanpage from './components/pages/Shanpage';


function App() {
  return (
    <Router>
    
    <div>

     
      
      <Routes>

      <Route axact path="/contact" element={<Contact/>}/>
      <Route axact path="/" element={<Home/>}/>
        <Route axact path="/about" element={<Aboutpage/>}/>
        <Route axact path="/doctor" element={<Doctorpage/>}/>
         <Route axact path="/clinci" element={<Shanpage/>}/>
       </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
